export default `float t = 1.0; 
  p.xz+=vec2(cos(p.z*5.+t*2.),sin(p.x*8.));
  p.xz*=rotate2D(.5-atan(p.x,p.z));
  return .1*(p.z-p.y*p.y-.3);
}`